import { z } from 'zod';

export const StripeNameCardForm = z.object({
  nameOnCard: z.string().min(2, 'STRIPE.NAME_CARD_ERROR'),
});

export const StripeCardForm = StripeNameCardForm.extend({
  setupIntentId: z.string().min(1),
});
